<div class="footer-outer">
    <div class="container footer">
        <div class="row">
            <div class="col-sm-4 footer-left">
                <p>&copy; Edenred Global Rewards</p>
            </div>

           <div class="col-md-4 document-link">
                <a href="assets\GRDataProtectionandPrivacyNoticeInternal-2021.pdf" target="_blank">Data Privacy Policy</a>
             </div>


            <div class="col-md-4 footer-right">
                <!-- <p>Site Map ! Need help ?</p> -->
            </div> 
              
        </div>
    </div>
</div>